import { render, staticRenderFns } from "./v-header.vue?vue&type=template&id=4f65a664&scoped=true&"
import script from "./v-header.vue?vue&type=script&lang=js&"
export * from "./v-header.vue?vue&type=script&lang=js&"
import style0 from "./v-header.vue?vue&type=style&index=0&id=4f65a664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f65a664",
  null
  
)

export default component.exports